const useAvatarProps = {
  color: { type: String, default: "primary" },
  textColor: { type: String },
  square: { type: Boolean, default: false },
  fontSize: { type: String, default: "" }
};
export {
  useAvatarProps as u
};
//# sourceMappingURL=useAvatarProps-7897713e.mjs.map
